<script>import {} from "../../../types/index.js";
export let prxImageV2Props;
</script>

<img
    class="prx-image{prxImageV2Props.additionalClasses ? ` ${prxImageV2Props.additionalClasses}` : ''}"
    src={prxImageV2Props.src}
    alt={prxImageV2Props.altText}
    title={prxImageV2Props.titleText ? prxImageV2Props.titleText : prxImageV2Props.altText}
/>

<style>.prx-image {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}</style>